// extracted by mini-css-extract-plugin
export default {"title1":"COATitle1-module--title1--38224","white":"COATitle1-module--white--c0dcf"};